export default {
    apiKey: "AIzaSyCKpV-ZditfnNYMIs1atbC9tcCRFQXaTLM",
    authDomain: "typewriter-app-c8966.firebaseapp.com",
    databaseURL: "https://typewriter-app-c8966.firebaseio.com",
    projectId: "typewriter-app-c8966",
    storageBucket: "typewriter-app-c8966.appspot.com",
    messagingSenderId: "1053984098056"
};



// WEBPACK FOOTER //
// ./src/firebaseConfig.js